import { render as solidRender } from 'solid-js/web'
import { MAOButton } from './mao-button'

function renderButtonIntoContainer({
  container,
  onClick,
  floating,
  label,
}: {
  container: HTMLElement
  onClick: () => void
  floating?: boolean
  label?: string
}) {
  return solidRender(
    () => (
      <MAOButton onClick={onClick} floating={floating}>
        {label}
      </MAOButton>
    ),
    container
  )
}

function attachButton({
  element,
  onClick,
}: {
  element: HTMLElement
  onClick: () => void
}) {
  element.addEventListener('click', onClick)
  return () => element.removeEventListener('click', onClick)
}

export function render({
  target,
  container,
  defaultButtonHost,
  onClick,
  label,
}: {
  target?: HTMLElement | null
  container?: HTMLElement | null
  defaultButtonHost: HTMLElement
  label?: string
  onClick: () => void
}) {
  if (target) {
    return attachButton({
      element: target,
      onClick: onClick,
    })
  }

  return renderButtonIntoContainer({
    container: container ?? defaultButtonHost,
    onClick,
    label,
    floating: !container,
  })
}
